import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import {
  getCartsFromDigitisationId,
  getDigitisationId,
  modifyCartData,
  placeFailedOrderCart,
  placeOrderByCartId,
  addSubstituteToCart,
  getPartnerStoresByCartId,
  getDetailsForApollocart
} from './UploadRxComponents/Services';

const buttonStyle = {
  padding: '8px 12px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  background: '#f0f0f0',
  color: '#333',
  fontSize: '16px',
  cursor: 'pointer',
  margin: '0 5px',
};

const quantityStyle = {
  padding: '8px 12px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  background: '#fff',
  color: '#333',
  fontSize: '16px',
  margin: '0 5px',
};

const RetryOrder = ({ onClose, orderId = null, ...props }) => {
  const [digitisationId, setDigitisationId] = useState(props.digitisationId || null);
  const [cartData, setCartData] = useState([]);
  const [policy, setPolicy] = useState({});
  const [cartPartnerList, setCartPartnerList] = useState([]);
  const [selectedCartIndex, setSelectedCartIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCart, setSelectedCart] = useState(null);
  const [partnerOptions, setPartnerOptions] = useState(['All']);
  const [selectedPartner, setSelecetdPartner] = useState('All');
  const [isCartUpdated, setIsCartUpdated] = useState(false);
  const [updatedCarts, setUpdatedCarts] = useState([]);
  const [retryOrderResponse, setRetryOrderResponse] = useState(null);
  const [isAnyUnaddedSubstitute, setIsAnyUnaddedSubstitute] = useState(false);
  const [isReplacementForCancelledOrder, setIsReplacement] = useState(false);
  const [apolloPickupStores, setApolloPickupStores] = useState([]);
  const [showPickupStores, setShowPickupStores] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [isApolloCartSelected, setIsApolloCartSelected] = useState(false);
  const [deliveryOption, setDeliveryOption] = useState(null);
  const [isHomeDeliveryAvailable, setIsHomeDeliveryAvailable] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsReplacement(e.target.checked);
  };

  useEffect(() => {
    async function getDigitisationIdOfOrderID() {
      const response = await getDigitisationId(orderId);
      if (response && response.status && response.status === 'success') {
        setDigitisationId(response.digitisationId);
        const cartResponse = await getCartsFromDigitisationId(
          response.digitisationId
        );
        if (cartResponse && cartResponse.carts) {
          setCartData(cartResponse.carts);
          setCartPartnerList(cartResponse.partners);
          setPolicy(cartResponse.policy);
          setPartnerOptions((prevData) => [...new Set([
            ...prevData,
            ...cartResponse.carts.map((cart) => {
              return cart.partnerName;
            }),
          ])]);
        } else {
          onClose();
        }
      }
    }
    if (orderId) {
      getDigitisationIdOfOrderID();
    }
  }, [orderId]);

  useEffect(() => {
    if (selectedCart) {
      const currentSelectedCart = cartData.find((cart) => cart.cartId === selectedCart);
      const isUnaddedSubExist = currentSelectedCart.medicines.some((cart) => cart.isSubstitute && !cart.isSubstituteAdded);
      setIsAnyUnaddedSubstitute(isUnaddedSubExist);
    }
  }, [selectedCart, cartData]);

  const handleCartSelection = async(index, cartId) => {

    const selectedCartData = cartData.find(cart => cart.cartId === cartId);
    if (selectedCartData && selectedCartData.partnerName === 'Apollo') {
    setIsApolloCartSelected(true);
    
      try {
        const response = await getDetailsForApollocart(cartId);
        if (response && response.message == 'success') {
          setIsHomeDeliveryAvailable(response.isHomeDeliveryAvailable || false);
        }
      } catch (error) {
        setIsHomeDeliveryAvailable(false);
      }
      setSelectedCartIndex(index);
      setSelectedCart(cartId);
    } else {
      setIsApolloCartSelected(false);
      setShowPickupStores(false);
      setDeliveryOption(null);
      setSelectedStore(null);
      setIsHomeDeliveryAvailable(false);
      setSelectedCartIndex(index);
      setSelectedCart(cartId);
    }

  };

  useEffect(() => {
    async function setCart() {
      const cartResponse = await getCartsFromDigitisationId(digitisationId);
      if (cartResponse && cartResponse.carts && cartResponse.carts) {
        setCartData(cartResponse.carts);
        setCartPartnerList(cartResponse.partners);
        setPolicy(cartResponse.policy);
        setPartnerOptions((prevData) => [...new Set([
          ...prevData,
          ...cartResponse.carts.map((cart) => {
            return cart.partnerName;
          }),
        ])]);
      } else {
        alert(`NOTE: ${cartResponse.message}`);
        onClose();
      }
    }
    if (!orderId && digitisationId) {
      setCart();
    }
  }, [digitisationId]);

  const modifyAndGetUpdatedCarts = async () => {
    try {
      setIsLoading(true);
      const asyncCalls = updatedCarts.map((cartId) =>
        modifyCartData(
          cartId,
          cartData.find((cart) => cart.cartId === cartId).medicines || null
        )
      );
      await Promise.all(asyncCalls);
      const cartResponse = await getCartsFromDigitisationId(digitisationId);
      if (cartResponse && cartResponse.carts) {
        setCartData(cartResponse.carts);
        setCartPartnerList(cartResponse.partners);
        setPolicy(cartResponse.policy);
        setPartnerOptions([
          'All',
          ...cartResponse.carts.map((cart) => {
            return cart.partnerName;
          }),
        ]);
      }
      setIsCartUpdated(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const decreaseQuantity = async (cartIndex, medIndex) => {
    const updatedCarts = [...cartData];
    if (updatedCarts[cartIndex].medicines[medIndex].quantity > 0) {
      setIsCartUpdated(true);
      setUpdatedCarts((prevState) => [
        ...prevState,
        updatedCarts[cartIndex].cartId,
      ]);
      updatedCarts[cartIndex].medicines[medIndex].quantity -= 1;
      setCartData(updatedCarts);
    }
  };

  const increaseQuantity = async (cartIndex, medIndex, maxQuant) => {

    if(cartData[cartIndex].medicines[medIndex].isSubstitute && !cartData[cartIndex].medicines[medIndex].isSubstituteAdded){
      // add substitute
      const isSubAddedSuccessFully = await addSubstituteToCart(cartData[cartIndex].cartId, cartData[cartIndex].medicines[medIndex].drugId);
      if(isSubAddedSuccessFully){
        await modifyAndGetUpdatedCarts()
      }
    }
    const updatedCarts = [...cartData];
    if (updatedCarts[cartIndex].medicines[medIndex].quantity < maxQuant) {
      setIsCartUpdated(true);
      setUpdatedCarts((prevState) => [
        ...prevState,
        updatedCarts[cartIndex].cartId,
      ]);
      updatedCarts[cartIndex].medicines[medIndex].quantity += 1;
      setCartData(updatedCarts);
    }
  };


  const placeOrder = async (cartId) => {
    // If store pickup is selected, fetch and show stores
    if (isApolloCartSelected && deliveryOption === 'pick-up' && !showPickupStores) {
      const partnerStoresResponse = await getPartnerStoresByCartId(cartId);
      if (partnerStoresResponse && partnerStoresResponse.success) {
        const storeList = partnerStoresResponse.storeLists || {};
        const pickupList = storeList.pickUpStores || [];

        setApolloPickupStores(pickupList);
        setShowPickupStores(true);
        return;
      }
    }
    
    let res = orderId 
      ? await placeFailedOrderCart(orderId, cartId) 
      : await placeOrderByCartId(cartId, isReplacementForCancelledOrder, selectedStore);
    setRetryOrderResponse(res);
  };

  const renderDetail = (label, value) => {
    if (!label) return null;

    const formattedLabel = label
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());

    const isURL = (val) => {
      if (typeof val !== 'string') return false;
      try {
        new URL(val);
        return true;
      } catch {
        return false;
      }
    };

    const isImageURL = (val) => {
      return typeof val === 'string' && /\.(jpeg|jpg|gif|png|svg|webp)$/i.test(val);
    };

    let displayValue;

    if (value === null || value === undefined || value === '') {
      displayValue = <span style={{ color: '#888' }}>N/A</span>;
    } else if (isURL(value)) {
      if (isImageURL(value)) {
        displayValue = (
          <img
            src={value}
            alt={formattedLabel}
            style={{
              width: '48px',
              height: '48px',
              objectFit: 'cover',
              borderRadius: '4px',
              border: '1px solid #ccc',
            }}
          />
        );
      } else {
        displayValue = (
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#0f4a11',
              fontWeight: 'bold',
              textDecoration: 'underline',
              wordBreak: 'break-word',
            }}
          >
            {value}
          </a>
        );
      }
    } else if (typeof value === 'boolean') {
      displayValue = (
        <span style={{ color: value ? '#0f4a11' : '#aa0000', fontWeight: 'bold' }}>
          {value ? 'Yes' : 'No'}
        </span>
      );
    } else if (typeof value === 'object') {
      displayValue = (
        <div style={{ marginLeft: '16px', marginTop: '4px' }}>
          {Object.entries(value).map(([nestedKey, nestedValue]) => (
            <div key={nestedKey}>{renderDetail(nestedKey, nestedValue)}</div>
          ))}
        </div>
      );
    } else {
      displayValue = <span style={{ color: '#0f4a11' }}>{value.toString()}</span>;
    }

    return (
      <div style={{ marginBottom: '8px' }}>
        <strong>{formattedLabel}:</strong> {displayValue}
      </div>
    );
  };

  return (
    <Modal
      isOpen={true}
      style={{
        maxWidth: '1200px',
        width: '100%',
        borderRadius: '4px',
        backgroundColor: 'yellow',
      }}
    >
      <ModalHeader style={{ backgroundColor: '#f2f0f5' }} toggle={onClose}>
        <h4
          className="text-center"
          style={{ color: '#999', fontWeight: 'bold' }}
        >
          Choose Cart To Place Order For Digitisation Id: {digitisationId}
        </h4>
      </ModalHeader>
      <ModalBody
        style={{
          paddingTop: '1%',
          paddingBottom: '5%',
          paddingInline: '5%',
        }}
      >
        <div>
          <h3 style={{ margin: '16px 0', fontSize: '24px', color: '#333' }}>Policy Detail</h3>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            {Object.entries(policy).map(([key, value]) => renderDetail(key, value))}
          </div>
        </div>
        <hr />
        <div>
          <h3 style={{ margin: '16px 0', fontSize: '24px', color: '#333' }}>
            Digitized Partners
          </h3>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '16px',
              alignItems: 'flex-start',
            }}
          >
            {Object.values(cartPartnerList).map((partner, index) => (
              <div
                key={index}
                style={{
                  width: '320px',
                  height: '230px',
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '16px',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  backgroundColor: '#fafafa',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
                }}
              >
                {/* Header with logo and name */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '12px',
                  }}
                >
                  {partner.partnerLogoUrl && (
                    <img
                      src={partner.partnerLogoUrl}
                      alt={partner.partnerName}
                      style={{
                        width: '32px',
                        height: '32px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        marginRight: '8px',
                      }}
                    />
                  )}
                  <h3
                    style={{
                      margin: 0,
                      fontSize: '18px',
                      color: '#0f4a11',
                      wordBreak: 'break-word',
                      flexGrow: 1,
                    }}
                  >
                    {partner.partnerName || `Partner ${index + 1}`}
                  </h3>
                </div>

                {/* Details scrollable */}
                <div
                  style={{
                    flexGrow: 1,
                    overflowY: 'auto',
                    paddingRight: '4px',
                  }}
                >
                  {Object.entries(partner).map(([key, value]) =>
                    key === 'partnerName' || key === 'partnerLogoUrl'
                      ? null
                      : renderDetail(key, value)
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <hr />
        <h3 style={{ margin: '16px 0', fontSize: '24px', color: '#333' }}>Carts</h3>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '0px 16px',
          }}
        >
          {cartData
            ? partnerOptions.map((partner, index) => (
                <button
                  key={index}
                  className={`btn btn-${
                    selectedPartner === partner ? 'primary' : 'secondary'
                  }`}
                  onClick={() => setSelecetdPartner(partner)}
                >
                  {partner}
                </button>
              ))
            : null}
        </div>
        {cartData ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              margin: 'auto',
              overflowX: 'auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                overflowX: 'auto',
                paddingBottom: '8px',
              }}
            >
              {cartData
                .filter(
                  (cart) =>
                    selectedPartner === 'All' ||
                    cart.partnerName === selectedPartner
                )
                .map((cart, cartIndex) => (
                  <div
                    key={cart.cartId}
                    onClick={() => handleCartSelection(cartIndex, cart.cartId)}
                    className="card"
                    style={{
                      margin: '8px 16px',
                      cursor: 'pointer',
                      minWidth: '300px',
                      border:
                        selectedCartIndex === cartIndex
                          ? '1px solid rgb(135, 82, 204) !important'
                          : '1px solid rgba(0, 0, 0, .125) !important',
                    }}
                  >
                    {isLoading && updatedCarts.includes(cart.cartId) ? (
                      <>
                        <div
                          className="card-header"
                          style={{
                            background: '#f0f0f0',
                            borderRadius: '4px 4px 0 0',
                            height: '20px',
                            marginBottom: '16px',
                          }}
                        >
                          <div
                            style={{
                              width: '80%',
                              height: '100%',
                              margin: 'auto',
                            }}
                          ></div>
                        </div>
                        <div
                          className="card-body"
                          style={{
                            background: '#f0f0f0',
                            borderRadius: '0',
                            height: '180px',
                            marginBottom: '16px',
                          }}
                        >
                          <div
                            style={{
                              width: '90%',
                              height: '40px',
                              marginBottom: '16px',
                            }}
                          ></div>
                          <div
                            style={{
                              width: '90%',
                              height: '40px',
                              marginBottom: '16px',
                            }}
                          ></div>
                          <div
                            style={{
                              width: '90%',
                              height: '40px',
                              marginBottom: '16px',
                            }}
                          ></div>
                        </div>
                        <div
                          className="card-footer"
                          style={{
                            background: '#f0f0f0',
                            borderRadius: '0 0 4px 4px',
                            height: '50px',
                            marginBottom: '16px',
                          }}
                        >
                          <div
                            style={{
                              width: '80%',
                              height: '100%',
                              margin: 'auto',
                            }}
                          ></div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="card-header">
                          <div className="row no-gutters">
                            <div className="col">
                              <label
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <div
                                  style={{
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '16px',
                                    lineHeight: '130%',
                                    letterSpacing: '0.25px',
                                    textAlign: 'left',
                                    textTransform: 'capitalize',
                                    margin: '0 16px',
                                  }}
                                >
                                  {cart.partnerName}
                                </div>
                                <input
                                  type="radio"
                                  name="partner"
                                  checked={selectedCartIndex === cartIndex}
                                  onChange={() =>
                                    handleCartSelection(cartIndex, cart.cartId)
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="card-body">
                          <ul class="list-group list-group-flush">
                            {cart.medicines.map((med, medIndex) => (
                              <li
                                key={med.cartItemId}
                                class="list-group-item"
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <div
                                  style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '200px',
                                    minWidth: '200px',
                                  }}
                                >
                                  {med.brandName}
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <button
                                    style={buttonStyle}
                                    onClick={() =>
                                      decreaseQuantity(cartIndex, medIndex)
                                    }
                                  >
                                    -
                                  </button>
                                  <span
                                    style={{
                                      padding: '8px 12px',
                                      border: '1px solid #ccc',
                                      borderRadius: '4px',
                                      background: med.isSubstitute ? '#e6f4ea' : med.isCovered === 0 ? 'orange' : '#fff',
                                      color: med.isSubstitute ? '#0f4a11' : '#333',
                                      fontSize: '16px',
                                      margin: '0 5px',
                                      fontWeight: med.isSubstitute ? 'bold' : 'normal',
                                    }}
                                  >
                                    {med.isSubstitute && !med.isSubstituteAdded ? 0 : med.quantity}
                                  </span>
                                  <button
                                    style={buttonStyle}
                                    onClick={() =>
                                      increaseQuantity(
                                        cartIndex,
                                        medIndex,
                                        med.maxQuantity
                                      )
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                                <div>₹{med.mrp}</div>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="card-footer">
                          <ul className="list-group list-group-flush">
                            <li
                              className="list-group-item"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div>Subtotal Amount</div>
                              <div>₹{cart.orderSubTotal}</div>
                            </li>
                            <li
                              className="list-group-item"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div>Visit Discount</div>
                              <div>- ₹{cart.orderDiscount}</div>
                            </li>
                            <li
                              className="list-group-item"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div>Total Amount</div>
                              <div>₹{cart.totalAmount}</div>
                            </li>
                            <li
                              className="list-group-item"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div>Order Type</div>
                              <div>{cart.orderType || 'code'}</div>
                            </li>
                            <li
                              className="list-group-item"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div>User Payable</div>
                              <div>₹{cart.userPay}</div>
                            </li>
                            <li
                              className="list-group-item"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div>Wallet Discount</div>
                              <div>₹{cart.walletDiscount || 0}</div>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                ))}
            </div>
          </div>
        ) : null}
        {cartData ? (
          retryOrderResponse ? (
            <div style={{ fontFamily: 'Arial, sans-serif', margin: '20px' }}>
              {retryOrderResponse.message && <p>Message: {retryOrderResponse.message.toString()}</p>}
              {retryOrderResponse.failedOrderDetail && <p>Failed Order Detail:</p>}
              {retryOrderResponse.failedOrderDetail && 
                <ul>
                  <li>Order ID: {retryOrderResponse.failedOrderDetail.orderId.toString()}</li>
                  <li>Replaced: {retryOrderResponse.failedOrderDetail.replaced.toString()}</li>
                  <li>Cancelled: {retryOrderResponse.failedOrderDetail.cancelled ? retryOrderResponse.failedOrderDetail.cancelled.toString() : 'NULL'}</li>
                  <li>Refund Required: {retryOrderResponse.failedOrderDetail.refundRequired ? retryOrderResponse.failedOrderDetail.refundRequired.toString() : 'NULL'}</li>
                  <li>Refunded: {retryOrderResponse.failedOrderDetail.refunded ? retryOrderResponse.failedOrderDetail.refunded.toString() : 'NULL'}</li>
                </ul>
              }
              <p>New Order Detail:</p>
              {retryOrderResponse.newOrderDetail &&
                <ul>
                  <li>Status: {retryOrderResponse.newOrderDetail.status.toString()}</li>
                  <li>Order ID: {retryOrderResponse.newOrderDetail.orderId.toString()}</li>
                  <li>Cancelled: {retryOrderResponse.newOrderDetail.cancelled ? retryOrderResponse.newOrderDetail.cancelled.toString() : 'NULL'}</li>
                  <li>Refund Required: {retryOrderResponse.newOrderDetail.refundRequired ? retryOrderResponse.newOrderDetail.refundRequired.toString() : 'NULL'}</li>
                  <li>Refunded: {retryOrderResponse.newOrderDetail.refunded ? retryOrderResponse.newOrderDetail.refunded.toString() : 'NULL'}</li>
                </ul>
              }
            </div>
          ) : isApolloCartSelected && !showPickupStores ? (
            <div style={{ marginTop: "20px", width: "100%" }}>
              <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>
                Choose Delivery Option
              </h3>
              
              {isHomeDeliveryAvailable && (
                <label style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                  <input
                    type="radio"
                    name="deliveryOption"
                    checked={deliveryOption === 'home-delivery'}
                    onChange={() => {
                      setDeliveryOption('home-delivery');
                    }}
                  />
                  Home Delivery
                </label>
              )}
              <label style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                <input
                  type="radio"
                  name="deliveryOption"
                  checked={deliveryOption === 'pick-up'}
                  onChange={() => {
                    setDeliveryOption('pick-up');
                  }}
                />
                Store Pickup
              </label>
              
              {!isHomeDeliveryAvailable && (
                <p style={{ color: "#666", fontSize: "14px", marginBottom: "10px" }}>
                  Home delivery is not available for this location. Please select store pickup.
                </p>
              )}
              <button
                className="btn btn-primary mt-4"
                disabled={!deliveryOption}
                onClick={() => isCartUpdated ? modifyAndGetUpdatedCarts() : placeOrder(selectedCart)}
              >
                {isCartUpdated ?  "Refresh Billing" : deliveryOption === 'pick-up' ? "Continue" : "Place Order"}
              </button>
            </div>
          ) : showPickupStores ? (
            <div style={{ width: "100%", marginBottom: "20px" }}>
              <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>
                Nearby Pickup Stores
              </h3>

              {apolloPickupStores.length > 0 ? (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "12px",
                  }}
                >
                  {apolloPickupStores.map((store, index) => (
                    <label
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        padding: "12px 0",
                        borderBottom:
                          index !== apolloPickupStores.length - 1
                            ? "1px solid #eee"
                            : "none",
                        cursor: "pointer",
                        gap: "10px",
                      }}
                    >
                      <input
                        type="radio"
                        name="pickupStore"
                        value={store.partnerStoreId}
                        checked={selectedStore === store.partnerStoreId}
                        onChange={() => {
                          setSelectedStore(store.partnerStoreId);
                        }}
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                          marginTop: "4px",
                        }}
                      />

                      <div>
                        <strong>{store.storeName} (ID : {store.partnerStoreId})</strong>
                        {store.isPickupOrderPlacedBefore && (
                        <span
                          style={{
                            marginLeft: "10px",
                            backgroundColor: "#e8f3ff",
                            color: "#0066cc",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            fontWeight: 500,
                          }}
                        >
                          Selected By User
                        </span>
                      )}
                        <p style={{ margin: 0, color: "#555", fontSize: "14px" }}>
                          {store.address}
                        </p>
                      </div>
                    </label>
                  ))}
                </div>
              ) : (
                <p style={{ color: "red", marginBottom: "8px" }}>
                  No pickup stores available for this location.
                </p>
              )}

              <button
                className="btn btn-primary px-6 py-2 text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed mt-4"
                disabled={
                  isLoading ||
                  selectedCartIndex === null ||
                  isAnyUnaddedSubstitute ||
                  (apolloPickupStores.length > 0 && selectedStore === null)
                }
                onClick={() =>
                  isCartUpdated ? modifyAndGetUpdatedCarts() : placeOrder(selectedCart)
                }
              >
                {isCartUpdated ? "Refresh Billing" : "Place Order"}
              </button>
            </div>
          ) : (
            <>
              {!isLoading && isAnyUnaddedSubstitute && (
                <p style={{ color: "red" }} className="text-sm text-red-600">
                  Please add all substitutes before placing the order.
                </p>
              )}

              <div style={{ display: "flex", alignItems: "center", margin: "16px 0" }}>
                <input
                  type="checkbox"
                  checked={isReplacementForCancelledOrder}
                  onChange={handleCheckboxChange}
                  style={{
                    width: "24px",
                    height: "24px",
                    marginRight: "12px",
                  }}
                  disabled={isLoading}
                />
                <label style={{ fontSize: "18px", fontWeight: "500", color: "#333" }}>
                  Is This Replacement for Cancelled Order
                </label>
              </div>

              <button
                className="btn btn-primary px-6 py-2 text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isLoading || selectedCartIndex === null || isAnyUnaddedSubstitute}
                onClick={() =>
                  isCartUpdated ? modifyAndGetUpdatedCarts() : placeOrder(selectedCart)
                }
              >
                {isCartUpdated ? "Refresh Billing" : "Place Order"}
              </button>
            </>
          )
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export default RetryOrder;